import { apiClient } from "./client";

export type PushPromptMode =
  | "subscribe"
  | "repair"
  | "install-ios"
  | "blocked"
  | null;

const isIos = () => /iPad|iPhone|iPod/.test(navigator.userAgent);
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  Boolean((navigator as Navigator & { standalone?: boolean }).standalone);

export const resolveNotificationPermission = async (): Promise<NotificationPermission> =>
  Notification.permission === "default"
    ? Notification.requestPermission()
    : Notification.permission;

export const pushService = {
  promptMode(): PushPromptMode {
    if (!("serviceWorker" in navigator) || !("Notification" in window)) {
      return isIos() && !isStandalone() ? "install-ios" : null;
    }
    if (!("PushManager" in window)) {
      return isIos() && !isStandalone() ? "install-ios" : null;
    }
    if (isIos() && !isStandalone()) return "install-ios";
    if (Notification.permission === "denied") return "blocked";
    return Notification.permission === "default" ? "subscribe" : null;
  },

  async subscribe(): Promise<void> {
    if (!("serviceWorker" in navigator) || !("PushManager" in window))
      throw new Error("Уведомления не поддерживаются этим браузером");
    const permission = await resolveNotificationPermission();
    if (permission !== "granted")
      throw new Error("Разрешение на уведомления не предоставлено");
    const registration = await navigator.serviceWorker.register("/push-sw.js");
    const ready = await navigator.serviceWorker.ready;
    const { data } = await apiClient.get<{ public_key: string }>(
      "/push/vapid-public-key",
    );
    const key = Uint8Array.from(
      atob(data.public_key.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(data.public_key.length / 4) * 4, "=")),
      (character) => character.charCodeAt(0),
    );
    const existing = await ready.pushManager.getSubscription();
    const subscription =
      existing ||
      (await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: key,
      }));
    await apiClient.post("/push/subscriptions", subscription.toJSON());
  },

  async ensureSubscribed(): Promise<void> {
    if (Notification.permission !== "granted") return;
    await this.subscribe();
  },
};
